export default __webpack_public_path__ + "f83260e8b4ae149298afc0e37c25008b.png";